function FooterComponent() {
    return (
        <footer className="footer">
            <span className="text-muted">All Rights Reserved 2023 @Shankar</span>
        </footer>
    )
}

export default FooterComponent